
    import I18n from 'i18nObj';
    
      import 'translations/conferences.new_conference';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('conferences.new_conference');
  